// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3BT4Y","body":"App_body__3UyqE","page":"App_page__3q1Qz","enter":"App_enter__3pyuR","exit":"App_exit__3C9zw"};